<template>
	<div>
		<div class="field">
			<label class="label">Título</label>
			<div class="control">
				<input 
					class="input"
					type="text" 
					name="name"
					id="name" 
					placeholder="Nombre o título" 
					v-model="mform.name"
					v-validate="'required'">
			</div>
				<transition name="fade">
					<span class="tag is-rounded" v-show="errors.has('name')">
						{{ errors.first('name') }}
					</span>
				</transition>
		</div>
		<div class="field">
			<label class="label">Correo electrónico</label>
			<div class="control">
				<input 
					class="input"
					type="text" 
					name="email"
					id="email" 
					v-model="mform.email"
					v-validate="'email'">
			</div>
				<transition name="fade">
					<span class="tag is-rounded" v-show="errors.has('email')">
						{{ errors.first('email') }}
					</span>
				</transition>
		</div>
		<div class="field">
			<label class="label">Filtros</label>
			<div class="control">
				<div class="columns">
					<div class="column">
						<label class="checkbox">
							<input type="checkbox" 
							v-validate="'required'"
							class="h-checkbox" 
							name="condition" 
							:value="1" 
							v-model="mform.condition">
							Año
						</label>
					</div>
					<div class="column">
						<label class="checkbox">
							<input type="checkbox" 
							v-validate="'required'"
							class="h-checkbox" 
							name="condition" 
							:value="2" 
							v-model="mform.condition">
							País
						</label>
					</div>
					<div class="column">
						<label class="checkbox">
							<input type="checkbox" 
							v-validate="'required'"
							class="h-checkbox" 
							name="condition" 
							:value="3" 
							v-model="mform.condition">
							Volumen
						</label>
					</div>
				</div>
			</div>
				<transition name="fade">
					<span class="tag is-rounded" v-show="errors.has('condition')">
						Debe de seleccionar algún filtro.
					</span>
				</transition>
		</div>
		<div class="field is-horizontal">
			<div class="field-label is-normal">
				<label class="label">Prioridad</label>
			</div>
			<div class="field-body">
				<div class="field has-text-left">
					<p class="control select">
						<select name="priority" id="priority" v-model="mform.priority">
							<option value="1">1 - Prioridad maxima</option>
							<option value="2">2</option>
							<option value="3">3 - Prioridad alta</option>
							<option value="4">4</option>
							<option value="5">5</option>
							<option value="6">6 - Prioridad media</option>
							<option value="7">7</option>
							<option value="8">8</option>
							<option value="9">9 - Prioridad baja</option>
							<option value="10">10 - Por defecto</option>
						</select>
					</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'FormArtist',
		props: ['formdata'],
		inject: ['$validator'],
		data() {
			return {
				mform: {
					name: "",
					email: "",
					condition: [],
					priority: 10,
				}
			}
		},
		created() {
			this.setInfo()
			this.emitForm()
		},
		watch: {
			formdata() {
				this.setInfo()
			},
			mform: {
				handler: function () {
					this.emitForm()
				},
				deep: true
			}
		},
		methods: {
			emitForm() {
				this.$emit('settingForm', this.mform)
			},
			setInfo() {
				if (typeof this.formdata != 'undefined') {
					if (typeof this.formdata.name != 'undefined') {
						this.mform.name = this.formdata.name
					}
					if (typeof this.formdata.email != 'undefined') {
						this.mform.email = this.formdata.email
					}
					if (typeof this.formdata.priority != 'undefined') {
						this.mform.priority = this.formdata.priority
					}
					if (typeof this.formdata.condition != 'undefined') {
						this.mform.condition = this.formdata.condition
					}
				}
			}
		}
	}
</script>